// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Kca-z","narrowOptionButtons":"Lca-z","noOptions":"Mca-z"};